import React from "react";
import Workflow from "../../../../editors/workflow";
import styles from "./styles.module.css";

export default function EventEditor({ block, event, sources, onChange }) {
  const handleChange = (value) => {
    const _block = { ...block };
    if (!_block.events) _block.events = {};
    _block.events[event.name] = value;
    onChange(_block);
  };
  return (
    <div className={styles.eventEditor}>
      <div className={styles.eventTitle}>{event.displayName}</div>
      <Workflow
        onChange={handleChange}
        sources={sources}
        value={block.events ? block.events[event.name] : null}
      />
    </div>
  );
}
